import React from 'react';
import Toggle from 'react-toggle';
import './styles.css';

export default (props: any) => {
  return <Toggle {...props} />;
};
